// extracted by mini-css-extract-plugin
export default {"timelineTitle":"Work_timelineTitle__yk4Ih","top":"Work_top__J71VK","horizontalScrollbar":"Work_horizontalScrollbar__eV1y5"};